import { Component, OnInit } from "@angular/core";

import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatRippleModule } from "@angular/material/core";

@Component({
  imports: [MatIconModule, MatButtonModule, MatRippleModule],
  selector: "vex-search-modal",
  template: `
    <div class="-m-6">
      <div class="flex items-center px-6 py-3 border-b gap-4 border-divider">
        <mat-icon
          svgIcon="mat:search"
          class="flex-none text-secondary"
        ></mat-icon>
        <input
          type="text"
          placeholder="Search..."
          class="flex-auto text-xl font-medium bg-transparent outline-none placeholder-secondary"
        />
        <button
          class="flex-none ltr:-mr-2 rtl:-ml-2 text-secondary"
          type="button"
          mat-icon-button
        >
          <mat-icon svgIcon="mat:settings"></mat-icon>
        </button>
      </div>

      <div class="p-4">
        <div class="px-2 mb-2 text-xs font-semibold text-secondary">
          Contacts
        </div>

        <div class="space-y-1">
          <div
            class="flex items-center px-2 py-2 rounded cursor-pointer select-none hover:bg-hover transition duration-200 ease-out gap-4"
            matRipple
          >
            <img
              src="assets/img/avatars/4.jpg"
              class="flex-none w-8 h-8 rounded-full"
            />
            <div class="flex-auto text-base font-medium">Alice Miller</div>
            <div
              class="flex items-center flex-none text-xs font-medium text-secondary gap-2"
            >
              <div>found in Contacts</div>
              <mat-icon
                svgIcon="mat:contacts"
                class="flex-none icon-xs"
              ></mat-icon>
            </div>
            <mat-icon
              svgIcon="mat:chevron_right"
              class="flex-none icon-sm"
            ></mat-icon>
          </div>

          <div
            class="flex items-center px-2 py-2 rounded cursor-pointer select-none hover:bg-hover transition duration-200 ease-out gap-4"
            matRipple
          >
            <img
              src="assets/img/avatars/3.jpg"
              class="flex-none w-8 h-8 rounded-full"
            />
            <div class="flex-auto text-base font-medium">Frank White</div>
            <div
              class="flex items-center flex-none text-xs font-medium text-secondary gap-2"
            >
              <div>found in Contacts</div>
              <mat-icon
                svgIcon="mat:contacts"
                class="flex-none icon-xs"
              ></mat-icon>
            </div>
            <mat-icon
              svgIcon="mat:chevron_right"
              class="flex-none icon-sm"
            ></mat-icon>
          </div>
        </div>
      </div>

      <div class="p-4">
        <div class="px-2 mb-2 text-xs font-semibold text-secondary">Pages</div>

        <div class="space-y-1">
          <div
            class="flex items-center px-2 py-2 rounded cursor-pointer select-none hover:bg-hover transition duration-200 ease-out gap-4"
            matRipple
          >
            <div
              class="flex items-center justify-center w-8 h-8 rounded-full bg-foreground/20"
            >
              <mat-icon svgIcon="mat:web" class="flex-none icon-sm"></mat-icon>
            </div>
            <div class="flex-auto text-base font-medium">
              <div>Scrumboard</div>
              <div class="text-xs text-secondary">/apps/scrumboard</div>
            </div>
            <mat-icon
              svgIcon="mat:chevron_right"
              class="flex-none icon-sm"
            ></mat-icon>
          </div>

          <div
            class="flex items-center px-2 py-2 rounded cursor-pointer select-none hover:bg-hover transition duration-200 ease-out gap-4"
            matRipple
          >
            <div
              class="flex items-center justify-center w-8 h-8 rounded-full bg-foreground/20"
            >
              <mat-icon svgIcon="mat:web" class="flex-none icon-sm"></mat-icon>
            </div>
            <div class="flex-auto text-base font-medium">
              <div>Mailbox</div>
              <div class="text-xs text-secondary">/apps/mailbox</div>
            </div>
            <mat-icon
              svgIcon="mat:chevron_right"
              class="flex-none icon-sm"
            ></mat-icon>
          </div>
        </div>
      </div>

      <div class="p-4">
        <div class="px-2 mb-2 text-xs font-semibold text-secondary">Tasks</div>

        <div class="space-y-1">
          <div
            class="flex items-center px-2 py-2 rounded cursor-pointer select-none hover:bg-hover transition duration-200 ease-out gap-4"
            matRipple
          >
            <div
              class="flex items-center justify-center w-8 h-8 rounded-full bg-foreground/20"
            >
              <mat-icon
                svgIcon="mat:check"
                class="flex-none icon-sm"
                color="primary"
              ></mat-icon>
            </div>
            <div class="flex-auto text-base font-medium">
              Configure OrderController as defined in RVT-11
            </div>
            <mat-icon
              svgIcon="mat:chevron_right"
              class="flex-none icon-sm"
            ></mat-icon>
          </div>

          <div
            class="flex items-center px-2 py-2 rounded cursor-pointer select-none hover:bg-hover transition duration-200 ease-out gap-4"
            matRipple
          >
            <div
              class="flex items-center justify-center w-8 h-8 rounded-full bg-foreground/20"
            >
              <mat-icon
                svgIcon="mat:check"
                class="flex-none icon-sm"
                color="primary"
              ></mat-icon>
            </div>
            <div class="flex-auto text-base font-medium">
              Add more data-models to product-controller
            </div>
            <mat-icon
              svgIcon="mat:chevron_right"
              class="flex-none icon-sm"
            ></mat-icon>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [``],
})
export class SearchModalComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
